import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';

const FreeHTML = ({ content }) => <div dangerouslySetInnerHTML={{ __html: purifier(content) }} />;

export default hot(module)(FreeHTML);
